(() => {
  const markSoldOutCards = (root = document) => {
    root.querySelectorAll('product-card').forEach((card) => {
      const badges = [...card.querySelectorAll('.badge')];
      const soldOut = badges.find((badge) => /sold\s*out|ausverkauft/i.test(badge.textContent || ''));
      if (!soldOut) return;
      card.classList.add('gv-sold-out');
      soldOut.textContent = 'AUSVERKAUFT';
      soldOut.classList.add('gv-sold-out__badge');
    });
  };

  markSoldOutCards();
  new MutationObserver(() => markSoldOutCards()).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', (event) => markSoldOutCards(event.target));
})();
